import { Container, ContainerProps, Paper } from "@mui/material";
import React from "react";
export function TextContainer(props: ContainerProps) {
  const { maxWidth = "md", ...other } = props;
  return (
    <Container style={{ paddingTop: 12 }} maxWidth={maxWidth} {...other}>
      <Paper style={{ padding: 24 }}>{props.children}</Paper>
    </Container>
  );
}
